import React, { useEffect } from 'react';
import { Button } from 'components'
import useApp from 'hooks/useApp'
import styles from './index.module.css'

const AgreeLayer = ({show, closeLayer}) => {

	const App = useApp()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: "",
			right: <i className="icon icon_close" />
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="flex_1 padding pt_20">
				<h3>마케팅 정보 수신동의</h3>
				<div className={`${styles["agree-terms"]} mt_40`}>
					<p className={styles["t-title"]}>제1장 총칙</p>
					<p>제 1조의 목적</p>
					<p>본 약관은 핀테크(이하 “회사”라 함)가 제공하는 “모니” 서비스(이하 “서비스”)의 이용과 관련하여, 회사와 이용자의 권리, 의무 및 책임사항, 서비스의 이용과 절차, 기타 필요한 사항을 규정함을 목적으로 합니다.</p>
					<p className={styles["s-title"]}>제 2조 용어의 정의</p>
					<p>
						이 약관에서 사용하는 용어의 정의는 아래와 같습니다.
						“서비스”라 함은 회사의 웹 사이트 및 모바일 어플리케이션을 통해 이용자에게 제공하는 서비스를 통칭하며, 이용자의 동의 하에 수집하거나 집적 입력한 정보를 확인할 수 있게 하는 서비스, 이용자의 정보와 금융상품별 혜택 정보를 분석하여 코칭을 제공하는 서비스, 맞춤형 금융상품을 추천하는 서비스, 금융 및 자동차 관련 컨텐츠 제공 서비스, 신용관리 서비스, 경력확인 서비스, 건강검진 결과 확인 서비스, 주거지 정보를 바탕으로 정보 제공 서비스 등으로 구성됩니다.
						“회원”이라 함은 회사의 서비스에 접속하여 이 약관에 따라 회사와 이용계약을 체결하고 회원을 대상으로 제공하는 서비스를 이용하는 고객을 말합니다.
						“비회원”이라 함은 회원에 가입하지 않고 회사가 제공하는 서비스를 이용하는 고객을 말합니다.
						“회원ID”라 함은 회원의 식별과 회원의 서비스 이용을 위하여 회원 가입 입력한 이메일 주소나 문자와 숫자, 특수문자등으로 이루어진 고유한 정보를 말합니다.
					</p>
				</div>
			</div>
			<div className="flex-shrink_0 padding">
				<Button className="btn btn--big" onClick={() => closeLayer()}>확인</Button>
			</div>
		</div>
	)
}

export default AgreeLayer